/**
 * 【【KYMW2300】ページ情報取得要求VO
 *
 * @export GetPageInfoModel
 * @class GetPageInfoModel
 */
export class GetPageInfoModel {
  /** 受注コード */
  public orderCode = String('');
  /** 媒体区分 */
  public mediumType = String('');
  /** 生協コード */
  public coopCode = String('');
  /** 工程番号 */
  public progressNum = String('');
}
